import React, { Fragment } from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { filterProducts } from '../utils/Utils'

import Layout from '../components/layout'
import Seo from '../components/seo'
import Hero from '../components/hero'
import ProductItem from '../components/ProductItem'
import Breadcrumbs from '../components/Breadcrumbs'

const ProductIndex = ({ data }) => {
  const categories = data.allWpCategory.nodes
  const originalProducts = data.allWpRwProduct.nodes
  const productIdsToFilter = data.wpPartnerSeite.partnerseite.disableProducts
  const products = filterProducts(originalProducts, productIdsToFilter)

  if (!products.length) {
    return (
      <Layout isHomePage>
        <Seo title="Verleih" />
        <p>
          Ups, etwas ist schief gelaufen, wir konnten keine Produkte laden.
          Bitte versuchen Sie es erneut.
        </p>
      </Layout>
    )
  }

  return (
    <Layout isHomePage>
      <Seo title="Verleih" />
      <div className="bg-white">
        <Hero title="Entdecken Sie Sicherheits&shy;­technik zur flexiblen Miete" />
        <div className="max-w-2xl px-4 pt-4 pb-16 mx-auto sm:pt-6 sm:pb-24 sm:px-6 lg:max-w-7xl lg:px-8">
          <div className="flex flex-wrap justify-center mt-6 gap-y-10 gap-x-6 md:gap-x-8 lg:gap-x-12 lg:gap-y-16">
            {categories.map(category => (
              <Fragment key={category.id}>
                {/* <div className="relative" key={category.id}>
                <Breadcrumbs sticky>
                  <li>{category.name}</li>
                </Breadcrumbs>
                <div className="max-w-2xl px-4 pt-4 pb-16 mx-auto sm:pt-6 sm:pb-24 sm:px-6 lg:max-w-7xl lg:px-8">
                  <div className="flex flex-wrap justify-center mt-6 gap-y-10 gap-x-6 md:gap-x-8 lg:gap-x-12 lg:gap-y-16"> */}
                {filterProducts(category.rwProducts.nodes, productIdsToFilter).map(product => {
                  if (product.rwItemInformation.oeffentlichGelistet === null) {
                    return
                  }
                  const featuredImage = {
                    data: product.featuredImage?.node?.localFile
                      ?.childImageSharp?.gatsbyImageData,
                    alt: product.featuredImage?.node?.altText || ``,
                  }

                  return (
                    <ProductItem
                      key={product.id}
                      product={product}
                      featuredImage={featuredImage}
                    />
                  )
                })}
                {/* </div>
                </div>
              </div> */}
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default ProductIndex

ProductIndex.propTypes = {
  data: PropTypes.object,
}

export const pageQuery = graphql`
  query {
    allWpCategory(
      filter: {
        count: { gt: 0 }
        rwProducts: {
          nodes: {
            elemMatch: {
              status: { eq: "publish" }
            }
          }
        }
      }
      sort: { name: DESC }
    ) {
      nodes {
        id
        count
        slug
        name
        rwProducts {
          nodes {
            rwItemInformation {
              oeffentlichGelistet
            }
            id
            slug
            status
            title
            featuredImage {
              node {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
        }
      }
    }
    allWpRwProduct(
      filter: { rwItemInformation: { oeffentlichGelistet: { ne: null } } }
      sort: { date: DESC }
    ) {
      nodes {
        uri
        title
        featuredImage {
          node {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 1)
              }
            }
          }
        }
      }
    }
    wpPartnerSeite {
      partnerseite {
        disableProducts {
          ... on WpRwProduct {
            id
          }
        }
        identity {
          primaryColour
        }
      }
    }
  }
`
